<!--
Author: jiangli
Date: 2024-04-22
Desc: 快速交易
 -->
<template>
    <div>
        <div class="quick-box">
            <el-tabs v-model="activeName" :before-leave="handleBeforeLeave" class="tab">
                <el-tab-pane v-if="$util.checkModuleid(100002001)" name="1">
                    <span
                        slot="label"
                        :class="{
                            'personal-buy-tab-disabled': $util.isPersonalBuyBusinessDisabled()
                        }"
                    >
                        购买基金
                    </span>
                    <quickBuy ref="pane1"></quickBuy>
                </el-tab-pane>
                <el-tab-pane v-if="$util.checkModuleid(100002002)" label="赎回" name="2">
                    <quickSell ref="pane2"></quickSell>
                </el-tab-pane>
                <el-tab-pane v-if="$util.checkModuleid(100002003)" name="3">
                    <span
                        slot="label"
                        :class="{
                            'personal-buy-tab-disabled': $util.isPersonalBuyBusinessDisabled()
                        }"
                    >
                        转换
                    </span>
                    <quick-change ref="pane3" change-type="change"></quick-change>
                </el-tab-pane>
                <el-tab-pane v-if="$util.checkModuleid(100002004)" name="4">
                    <span
                        slot="label"
                        :class="{
                            'personal-buy-tab-disabled': $util.isPersonalBuyBusinessDisabled()
                        }"
                    >
                        赎回转申购
                    </span>
                    <quick-change ref="pane4" change-type="buy"></quick-change>
                </el-tab-pane>
                <el-tab-pane
                    v-if="
                        $util.checkModuleid(100002005) && showCrossSystemTransferDisplay !== false
                    "
                    label="跨系统转托管"
                    name="5"
                >
                    <trusteeship-list ref="pane5"></trusteeship-list>
                </el-tab-pane>
                <el-tab-pane
                    v-if="$util.checkModuleid(100002006) && showTransferCombTrusteeInDisplay"
                    label="转托管入直销"
                    name="6"
                >
                    <div v-if="activeName == 6">
                        <transferCombTrusteeIn></transferCombTrusteeIn>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
        <belongToConsignment ref="belongToConsignment"></belongToConsignment>
    </div>
</template>

<script>
import quickBuy from "../../components/fund/quickBuy.vue";
import quickSell from "./quickSell.vue";
import quickChange from "../../components/fund/quickChange.vue";
import trusteeshipList from "../../components/fund/trusteeshipList.vue";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import transferCombTrusteeIn from "../../bizcomponents/fund/transferCombTrusteeIn.vue";
import warningHtml from "@/constant/warning_html.js";
import belongToConsignment from "@/components/fund/belongToConsignment.vue";

export default {
    name: "QuickTrade",
    components: {
        quickBuy,
        quickSell,
        quickChange,
        trusteeshipList,
        footerQuestions,
        transferCombTrusteeIn,
        belongToConsignment
    },
    data() {
        return {
            activeName: "1",
            commonQuestion: [], // 常见问题
            warningHtml: "", // 温馨提示
            showCrossSystemTransferDisplay: true, // 跨系统转托管业务入口开关
            showTransferCombTrusteeInDisplay: false // 转托管入直销业务入口开关
        };
    },
    watch: {
        activeName(val) {
            if (this.$refs["pane" + val] && this.$refs["pane" + val]["getList" + val]) {
                this.$refs["pane" + val].pageoffset = 1;
                this.$refs["pane" + val]["getList" + val]();
            } else if (this.$refs["pane" + val] && this.$refs["pane" + val]["getList"]) {
                this.$refs["pane" + val].pageoffset = 1;
                this.$refs["pane" + val]["getList"]();
            }
            this.assignTipAndQuestion();
        }
    },

    created() {
        if (this.$route.query && this.$route.query.tab) {
            this.activeName = this.$route.query.tab;
        }
    },
    mounted() {
        this.showCrossSystemTransferDisplay =
            this.$cache.getParamValue("business_module") &&
            this.$cache.getParamValue("business_module").bizenable["026"];
        this.showTransferCombTrusteeInDisplay =
            this.$cache.getParamValue("business_module") &&
            this.$cache.getParamValue("business_module").bizenable["027"];
        this.normalizeActiveTab();
        setTimeout(() => {
            this.assignTipAndQuestion();
        }, 1000);
    },
    methods: {
        normalizeActiveTab() {
            if (
                this.$util.isPersonalBuyBusinessDisabled() &&
                ["1", "3", "4"].includes(this.activeName)
            ) {
                const firstEnabledTab = [
                    { name: "2", enabled: this.$util.checkModuleid(100002002) },
                    {
                        name: "5",
                        enabled:
                            this.$util.checkModuleid(100002005) &&
                            this.showCrossSystemTransferDisplay !== false
                    },
                    {
                        name: "6",
                        enabled:
                            this.$util.checkModuleid(100002006) &&
                            this.showTransferCombTrusteeInDisplay
                    }
                ].find((item) => item.enabled);
                if (firstEnabledTab) {
                    this.activeName = firstEnabledTab.name;
                }
            }
        },
        // 赋值温馨提示和常见问题
        assignTipAndQuestion() {
            if (this.activeName == "1") {
                this.commonQuestion = this.$const.commonQuestion.commonQuestion3;
                this.warningHtml = warningHtml.warningHtml7;
            } else if (this.activeName == "2") {
                this.commonQuestion = this.$const.commonQuestion.commonQuestion7.map((item) => {
                    if (item.title === "4.赎回款一直没有到账，是什么原因？") {
                        // 对 answer 进行处理
                        const formattedAnswer = item.answer
                            // 将电话号码更换
                            .replace(/(400 888 5558)/, this.$cache.getCompanyInfoParam("10101009"));

                        // 返回新对象，保留其他属性
                        return { ...item, answer: formattedAnswer };
                    }
                    return item; // 其他条目保持不变
                });
                this.warningHtml = warningHtml.warningHtml8;
            } else if (this.activeName == "3") {
                this.commonQuestion = this.$const.commonQuestion.commonQuestion8;
                this.warningHtml = warningHtml.warningHtml9;
            } else if (this.activeName == "4") {
                this.commonQuestion = [];
                this.warningHtml = warningHtml.warningHtml10;
            } else if (this.activeName == "5") {
                this.commonQuestion = this.$const.commonQuestion.commonQuestion9;
                this.warningHtml = "";
            }
        },
        handleBeforeLeave(newTab, oldTab) {
            const info = this.$cache.getUser();
            const disabledBusinessName = {
                1: "认申购",
                3: "转换",
                4: "赎回转申购"
            }[newTab];
            if (
                disabledBusinessName &&
                this.$util.checkPersonalBuyBusinessDisabled(disabledBusinessName)
            ) {
                return false;
            }
            // 纯代销用户不能进入转托管入直销
            if (newTab === "6" && info.custbelongto == "2") {
                this.$refs.belongToConsignment.openDialog();
                return false; // 阻止切换
            }
            return true; // 允许切换
        }
    }
};
</script>

<style lang="scss">
.quick-box {
    background: var(--color-bg-page);
    border: 1px solid var(--color-divided);
    position: relative;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__header {
            margin-bottom: 10px;
        }
        .el-tabs__nav-wrap:after {
            background: var(--color-divided);
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: var(--color-primary);
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .personal-buy-tab-disabled {
                color: var(--color-text-placeholder);
                cursor: not-allowed;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
}
</style>
